import axios from "axios";
import { getAPIURL, getVendorID } from "./helper";

const api_url = getAPIURL();
const vendor_id = getVendorID();

// Assuming the base URL is already included in getAPIURL, you might adjust it depending on your configuration
axios.interceptors.request.use(
  (config) => {
    if (
      !config.url.endsWith("/upload") &&
      !config.url.endsWith("/upload/audio")
    ) {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const saveVendorData = async (data) => {
  try {
    const payload = { vendor_id, vendor_data: data };
    const response = await axios.post(`${api_url}/save-vendor-data`, payload);
    // console.log("Data saved successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Error saving vendor data:",
      error.response ? error.response.data : error.message
    );
    throw error; // Rethrow to let the caller handle it
  }
};

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  saveVendorData, // Export the function so it can be used elsewhere in your application
};
